import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ReleaseNotesData, ReleaseNotesService } from '../../_services/release-notes.service';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dialog-release-notes',
  templateUrl: './dialog-release-notes.component.html',
  styleUrls: ['./dialog-release-notes.component.css'],
  imports: [
    SharedModule, 
    MatDialogContent, 
    MatDialogActions, 
    MatDialogTitle,
    MatButtonModule
  ]
})
export class DialogReleaseNotesComponent implements OnInit {

  releaseNotes: ReleaseNotesData | null = null;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<DialogReleaseNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReleaseNotesData,
    private releaseNotesService: ReleaseNotesService // 1. Injete o serviço aqui
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.releaseNotes = this.data;
    }
  }

  close(): void {
    // Se fechar sem clicar em 'Entendi', não grava no localStorage
    this.dialogRef.close();
  }

  confirm(): void {
    // 2. Salva no localStorage SOMENTE quando clicar em "Entendi"
    if (this.releaseNotes?.version) {
      this.releaseNotesService.markVersionAsSeen(this.releaseNotes.version);
    }
    this.dialogRef.close();
  }
}